<template>
  <div>
    <payin-form
      :is-active.sync="isEditing"
      method="put"
      :fee="editingOffer"
      @changed="offerUpdated"
    />
    <payin-form :is-active.sync="isAdding" @changed="offerAdded" />
    <data-table
      title="Withdraw Countries"
      ref="table"
      :url="url"
      :headers="headers"
      :archive="false"
      item-key="id"
      searchable
      @click:row="showConfigurationDetails"
    >
      <v-btn slot="action.icons" color="primary" @click="isAdding = true">
        Add A country fee configuration
        <v-icon class="ml-2" color="light-blue lighten-4"> mdi-account-money</v-icon>
      </v-btn>
    </data-table>
  </div>
</template>
<script>
import PayinForm from "./form.vue";
export default {
  components: {
    PayinForm,
  },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      offer: {},
      editingOffer: null,
      url: `api/v1/transactions/feeConfigurations/${this.$route.params.id}/countryWithdraw`,
      headers: this.pairTableLabelWithValue({
        Id: "id",
        Country: "country.name",
        FeeType: "fee_type.name",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    feeConfigurationId() {
      return this.$route.params.id;
    },
  },
  created() {},
  methods: {
    showConfigurationDetails({ id }) {
      return this.$router.push({
        name: "withdraws.countries.show",
        params: { id, feeConfigurationId: this.feeConfigurationId },
      });
    },
    offerAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    offerUpdated({ message }) {
      this.editingOffer = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateOffer(offer) {
      this.editingOffer = Object.assign({}, offer);
      this.isEditing = true;
    },
  },
};
</script>
